export default {
  productBlock: {
    title: {
      en: 'Turn this...',
    },
    subtitle: {
      en: 'regular retail price',
    },
  },
  subscriptionBlock: {
    title: {
      en: 'Into this',
    },
    subtitle: {
      en: 'first month',
    },
  },
}
